import { createSlice } from '@reduxjs/toolkit';
import communicationsState from '../../../constants/integrations/communicationsState';

export const communicationsSlice = createSlice({
  name: 'communications',
  initialState: communicationsState,
  reducers: {
    setSelectedPlatform: (state, action) => {
      state.etc.selectedPlatform = action.payload;
    },
    resetCommunicationsState: () => communicationsState,
  },
});

export const { setSelectedPlatform, resetCommunicationsState } = communicationsSlice.actions;

export default communicationsSlice.reducer;
